import { render, staticRenderFns } from "./UgcHomeCarousel.vue?vue&type=template&id=a8e11b90&lang=pug"
import script from "./UgcHomeCarousel.vue?vue&type=script&lang=js"
export * from "./UgcHomeCarousel.vue?vue&type=script&lang=js"
import style0 from "./UgcHomeCarousel.vue?vue&type=style&index=0&id=a8e11b90&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports